import { makeStyles, Theme, createStyles, Typography } from "@material-ui/core";
import React from "react";
import { ConnectionConfigDataRow } from "../../../../types/config";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      fontSize: "0.875rem",
      marginTop: theme.spacing(2),
      marginButtom: theme.spacing(2),
    },
  })
);

interface Props {
  rowData: ConnectionConfigDataRow;
}

/** パス/端末機種表示コンポーネント */
export function PathAndConnectionDeviceRenderComponent(props: Props) {
  const classes = useStyles();

  const { rowData } = props;
  const { connectionDevice } = rowData.pathAndConnectionDevice;

  //--------------------
  // コンポーネント
  return (
    <>
      <div>
        <Typography className={classes.typography} component="span">
          {rowData.pathAndConnectionDevice.path
            ? rowData.pathAndConnectionDevice.path
            : "未登録"}
        </Typography>
      </div>
      <div>
        <Typography className={classes.typography} component="span">
          {connectionDevice !== null && "name" in connectionDevice
            ? connectionDevice.name
            : "未選択"}
        </Typography>
      </div>
    </>
  );
}
